import { GtmActionsTypes, INITIALIZE_GTM, INITIALIZE_GTM_TAG_STEPS, UPDATE_CONTAINER_ID } from './gtm.action';
import { GtmState, initialState } from './gtm.state';

// Reducer
export default (state: GtmState = initialState, action: GtmActionsTypes): GtmState => {
  switch (action.type) {
    case UPDATE_CONTAINER_ID: {
      return {
        ...state,
        containerId: action.payload,
      };
    }
    case INITIALIZE_GTM: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case INITIALIZE_GTM_TAG_STEPS: {
      return {
        ...state,
        gtmTagSteps: action.payload,
      };
    }
    default:
      return state;
  }
};
